"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reactDOMRender = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("react-dom/client");
const ErrorHandlerComponent_1 = require("Views/Partials/Components/ErrorHandler/ErrorHandlerComponent");
const reactDOMRender = (component, element) => {
    const root = (0, client_1.createRoot)(element);
    root.render((0, jsx_runtime_1.jsx)(ErrorHandlerComponent_1.ErrorHandlerComponent, { children: component }));
};
exports.reactDOMRender = reactDOMRender;
